export const list = (dispatch, apiClient) => {
  dispatch({ type: 'CUSTOMER_GROUPS_PENDING' });
  return apiClient
    .call({
      endpoint: 'customerGroups/list'
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'CUSTOMER_GROUPS_LIST', list: res.data });
    })
    .catch(e => {
      dispatch({ type: 'CUSTOMER_GROUPS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get group list",
        snackType: 'warning'
      });
      throw e;
    });
};

export const getGroups = (dispatch, apiClient) => {
  dispatch({ type: 'CUSTOMER_GROUPS_PENDING' });
  return apiClient
    .call({
      endpoint: 'customerGroups/getGroups'
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'CUSTOMER_GROUPS_LIST', list: res.data });
    })
    .catch(e => {
      dispatch({ type: 'CUSTOMER_GROUPS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't fetch group list",
        snackType: 'warning'
      });
      throw e;
    });
};

export const setDistributor = (dispatch, apiClient, CustomerGroupID, state) => {
  return apiClient
    .call({
      endpoint: 'customerGroups/setDistributor',
      data: { CustomerGroupID, state }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: 'Updated customer group',
        snackType: 'warning'
      });
      list(dispatch, apiClient);
    })
    .catch(e => {
      dispatch({ type: 'CUSTOMER_GROUPS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't fetch group list",
        snackType: 'warning'
      });
      throw e;
    });
};



// WEBPACK FOOTER //
// ./app/actions/customerGroups.js